var path = 'scripts/views/components/bca-info.html';
var html = "<div class=\"h3 mtn inline-blk vert-align-top\">\n    <span class=\"fa fa-folder mrs\"></span>\n</div>\n<div class=\"inline-blk\" id=\"bca-identifiers\">\n    <p ng-repeat=\"identifier in $ctrl.bcaIdentifiers()\" title={{identifier}} class=\"mbn mtn break-words\" ng-class=\"{ 'h3': $index == 0 }\"\n       style=\"text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 25ch;\n    cursor: pointer;\">{{identifier}}</p>\n    <p id=\"site-name\" class=\"medium-small-font mtn break-words\"><em>{{$ctrl.siteName()}}</em></p>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/bca-info.html
// module id = 304
// module chunks = 0